import { render, staticRenderFns } from "./DatatableListNotifications.vue?vue&type=template&id=5128e0c9"
import script from "./DatatableListNotifications.vue?vue&type=script&lang=js"
export * from "./DatatableListNotifications.vue?vue&type=script&lang=js"
import style0 from "./DatatableListNotifications.vue?vue&type=style&index=0&id=5128e0c9&prod&lang=css"
import style1 from "./DatatableListNotifications.vue?vue&type=style&index=1&id=5128e0c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports